export function getCookieShopify() {
    var _a;
    var result = (_a = document.cookie
        .split("; ")
        .find((row) => row.startsWith("_shopify_y="))) === null || _a === void 0 ? void 0 : _a.split("=")[1];
    // if result is undefined, return a random generate value with an structure like this: 71D3BD81-5ee2-4298-a12f-4014e098cc8f, but must be generate here
    /*if (!result || result === "") {
        result = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = crypto.getRandomValues(new Uint8Array(1))[0] % 16;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }*/
    return result || "";
}
